import MarketingLayout from './_layout';

const milestones = [
  { year: '2021', label: 'Founded with a vision for unified professional tooling.' },
  { year: '2023', label: 'Launched messaging, social, and commerce in a single product.' },
  { year: '2024', label: 'Crossed 10,000 companies and added integrated wallet & payments.' },
  { year: '2026', label: 'Expanded to 30+ countries with AI copilots across every module.' },
];

const values = [
  { title: 'One product, many problems', desc: 'We refuse to fragment user experience just because the underlying domains are complex.' },
  { title: 'Default to transparent', desc: 'Pricing, security posture, and roadmap — published, not buried.' },
  { title: 'Operate at scale, ship like a startup', desc: 'Fortune 500 reliability with the cadence of a 20-person team.' },
];

export default function AboutPage() {
  return (
    <MarketingLayout
      title="About Messego"
      subtitle="We are building the operating system for the modern professional — work, money, and network in one place."
    >
      <section className="space-y-12">
        <div className="bg-neutral-50 dark:bg-neutral-950 rounded-[2rem] border border-neutral-100 dark:border-neutral-800 p-8 md:p-12 space-y-4">
          <h2 className="text-2xl font-bold">Our story</h2>
          <p className="text-neutral-500 dark:text-neutral-400 leading-relaxed">
            Messego started as a frustration with the fragmentation of professional tooling. Our founders had teams
            living in eight tabs at once — chat in one, payments in another, talent in a third — and decided to build
            the unified workspace they wished existed. Today, Messego serves tens of thousands of businesses and
            professionals across every continent, and we are just getting started.
          </p>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-bold">Milestones</h2>
          <div className="space-y-3">
            {milestones.map((m, i) => (
              <div key={i} className="flex gap-6 p-6 bg-white dark:bg-neutral-900 rounded-2xl border border-neutral-200 dark:border-neutral-800">
                <div className="text-xl font-bold w-16 flex-shrink-0">{m.year}</div>
                <p className="text-neutral-500 dark:text-neutral-400 leading-relaxed">{m.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-bold">What we believe</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {values.map((v, i) => (
              <div key={i} className="p-6 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-2xl space-y-2">
                <h3 className="font-bold">{v.title}</h3>
                <p className="text-sm text-neutral-500 dark:text-neutral-400 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
